export enum TAB_IDS {
    about = '1',
    jury = '2',
    projects = '3',
    shortlist = '4',
    results = '5',
}export enum TAB_IDS {
    about = '1',
    jury = '2',
    projects = '3',
    shortlist = '4',
    results = '5',
}